import { getRequest } from "../../app/axiosClient";
import { setAppointmentDetails, setPatientAppointments } from "./PatientSlice";
import {
  showLoader,
  hideLoader,
} from "../../CommonComponents/GlobalSpinner/GlobalSpinnerSlice";

export const GetPatientAppointmentsApi = (patientId) => (dispatch) => {
  try {
    dispatch(showLoader());
    return getRequest(`api/appointments/patient/${patientId}`)
      .then((res) => {
        dispatch(setPatientAppointments(res?.data));
        dispatch(hideLoader());
        return { payload: res?.data };
      })
      .catch((e) => {
        dispatch(hideLoader());
        console.error("Error fetching claims:", e);
      });
  } catch (e) {
    return false;
    dispatch(hideLoader());
  }
};

export const GetAppointmentDetailsApi = (patientId) => (dispatch) => {
  try {
    dispatch(showLoader());
    return getRequest(`api/appointments/${patientId}`)
      .then((res) => {
        dispatch(setAppointmentDetails(res?.data));
        dispatch(hideLoader());
        return { payload: res?.data };
      })
      .catch((e) => {
        dispatch(hideLoader());
        console.error("Error fetching claims:", e);
      });
  } catch (e) {
    dispatch(hideLoader());
    return false;
  }
};
